import React from 'react'
import {withTooltip} from '@modifi/ui'

import {UserInitials, UserLogo} from './styles'
import {getModifiColorByName} from './utils'

const capitalize = (val: string): string =>
  val ? String(val).charAt(0).toUpperCase() + String(val).slice(1).toLowerCase() : ''

const UserLogoWithTooltip = withTooltip(UserLogo)

type ModifiUserLogoProps = {
  email?: string
}

const ModifiUserLogo: React.FC<ModifiUserLogoProps> = ({email = ''}) => {
  if (!email) return null
  if (!email?.endsWith('@modifi.com')) {
    return <UserInitials>{email?.slice(0, 2).toUpperCase()}</UserInitials>
  }

  const emailNamePart = email.split('@')[0]
  const splitter = emailNamePart.includes('.') ? '.' : '-'
  const [firstName, ...rest] = emailNamePart.split(splitter)
  const lastName = rest.join(' ')

  const {textColor, bgColor} = getModifiColorByName(firstName, lastName)

  return (
    <UserLogoWithTooltip
      tooltipTheme="dark"
      tooltipPlacement="top"
      tooltipContent={`${capitalize(firstName)} ${capitalize(lastName)}`}
      bgColor={bgColor}
    >
      <UserInitials textColor={textColor}>{firstName.charAt(0) + lastName.charAt(0)}</UserInitials>
    </UserLogoWithTooltip>
  )
}

export default ModifiUserLogo
